import styled from "styled-components";

export const ButtonWrapper = styled.div`
  min-width: 120px;
  height: 36px;

  :not(:first-child) {
    margin-left: 32px;
  }
`;

export const Container = styled.div`
  width: 538px;
`;

export const TitleContainer = styled.div`
  margin-bottom: 20px;
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: 50px;
`;

export const InnerContent = styled.div`
  margin-top: 24px;
`;
